export default {
  HANDLE_HTTP_IN_PROGRESS: 'handleHttpInProgress',
};



// WEBPACK FOOTER //
// ./src/app/shared/http-in-progress/constants/action-types.js